import { classEnum } from "./base";

export const ComplaintStatusEnum = new (class extends classEnum([
    {
        label: "Menunggu",
        value: "W",
    },
    {
        label: "Diproses",
        value: "P",
    },
    {
        label: "Dibatalkan",
        value: "C",
    },
    {
        label: "Selesai",
        value: "D",
    },
]) {
    public get valuesOngoing() {
        return this.values.filter((v) => v !== "C" && v !== "D");
    }

    public get ValuesOngoing(): this["valuesOngoing"][number] {
        throw new Error("ValuesOngoing can't be used as a value");
    }
})();

export namespace ComplaintStatusEnum {
    export type Labels = (typeof ComplaintStatusEnum)["labels"][number];
    export type Values = (typeof ComplaintStatusEnum)["values"][number];
    export type ValuesOngoing = (typeof ComplaintStatusEnum)["valuesOngoing"][number];
}
